export const instanceOfImage = (obj: any): obj is ImageV3State.Image => {
  return obj.piecesExchange !== undefined && obj.piecesResolved !== undefined;
};

export const instanceOfMaterial = (obj: any): obj is ImageV3API.Material => {
  return obj.toolId !== undefined;
};

export const instanceOfEvoResult = (
  obj: any
): obj is ImageV3API.EvolutionResult => {
  return obj.cost !== undefined;
};
